module.exports = __webpack_public_path__ + "img/304.4cd27e99.jpg";